import { StreamId, streamId, StreamName, streamName } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class MixerVideoStreamAddCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerVideoStreamAddCmd.validationSchema()
  );

  readonly value: MixerVideStreamAdd;

  constructor(value: MixerVideStreamAdd) {
    this.value = JsonSchemaValidator.assert(
      MixerVideoStreamAddCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["streamId", "streamName"],
      properties: {
        streamId,
        streamName
      },
      additionalProperties: false
    };
  }
}

interface MixerVideStreamAdd {
  streamId: StreamId;
  streamName: StreamName;
}
